<template>
  <div class="changelog-reaction-bar">
    <span
      v-if="entry.reactionFailed"
      role="status"
      class="changelog-reaction-bar__error">Couldn't save — try again</span>
    <button
      v-for="option in OPTIONS"
      :key="option.kind"
      v-tooltip="option.label"
      type="button"
      class="changelog-reaction-bar__btn"
      :class="{ 'changelog-reaction-bar__btn--active': entry.myReaction === option.kind }"
      :disabled="entry.reactionPending"
      :aria-pressed="entry.myReaction === option.kind"
      :aria-label="ariaLabelFor(option)"
      @click="store.toggleReaction(entry, option.kind)">
      <i :class="iconFor(option)" />
      <span v-if="countFor(option) !== null" class="changelog-reaction-bar__count">{{ countFor(option) }}</span>
    </button>
  </div>
</template>

<script setup>
import { useChangelogStore, countKey } from '@/stores/changelog'

const props = defineProps({
  entry: { type: Object, required: true }
})

const store = useChangelogStore()

const OPTIONS = [
  { kind: 'thumbs_up', icon: 'fa-thumbs-up', label: 'Helpful' },
  { kind: 'thumbs_down', icon: 'fa-thumbs-down', label: 'Not helpful' }
]

// Outline at rest, solid when selected — same affordance as the docs
// article thumbs vote.
const iconFor = (option) => `${props.entry.myReaction === option.kind ? 'fa-solid' : 'fa-regular'} ${option.icon}`

// Counts exist only in admin payloads — regular users get no `reactions` key.
const countFor = (option) => props.entry.reactions?.[countKey(option.kind)] ?? null

// Admin counts are part of the control's meaning — aria-label would otherwise
// prune the count span from the accessible name.
const ariaLabelFor = (option) => {
  const count = countFor(option)
  return count === null ? option.label : `${option.label} — ${count}`
}
</script>
